/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogStatus from 'layout/dialog/DialogStatus';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import Button from 'components/common/Button';

export default function RemoveUserSuccessDialog({ dialog, toggleDialog, result }) {
  const { t } = useTranslation();

  return (
    <Dialog data-testid="delete-account-result-dialog" open={dialog.open} fullWidth maxWidth="md">
      <DialogTitle>
        <DialogStatus variant={result === undefined ? 'success' : 'error'} />
        <Typography component="h3" variant="h3">
          {t('user.management.delete-account.success.dialog.title')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {result === undefined
          ? t('user.management.delete-account.success.dialog.description')
          : t('user.management.delete-account.success.dialog.error.description')}
      </DialogContent>
      <DialogActions>
        <Button data-testid="close-btn" color="default" onClick={() => toggleDialog(false)}>
          {t('button.ok.label')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
